export interface PropertyRow {
  propertyId: string;
  roomTypeId: string;
}

// One row per other property that has a room type with the selected name. Ticking a row always creates
// a new plan there, never edits an existing one; a property that already has a plan is still listed
// because stacking plans (by name, priority and dates) at one property is normal.
export function getPropertyRows(
  roomTypesWithSameName: Array<PropertyRow>,
  accessiblePropertyIds: Array<string>,
  currentPropertyId?: string | null
): PropertyRow[] {
  const seen = new Set<string>();

  return roomTypesWithSameName.filter(({ propertyId }) => {
    if (propertyId === currentPropertyId) return false;
    if (!accessiblePropertyIds.includes(propertyId)) return false;
    if (seen.has(propertyId)) return false;

    seen.add(propertyId);
    return true;
  });
}

// The ticked rows that still match a listed row for the same room type. After the room type changes, a
// property can stay listed under a different room type; the old tick must not carry over to it.
export function getSelectedPropertyIds(
  selected: Array<PropertyRow>,
  rows: Array<PropertyRow>
): string[] {
  const roomTypeByProperty = new Map(rows.map(r => [r.propertyId, r.roomTypeId]));

  return selected
    .filter(s => roomTypeByProperty.get(s.propertyId) === s.roomTypeId)
    .map(s => s.propertyId);
}
